import { render, staticRenderFns } from "./cardvalue.vue?vue&type=template&id=a4181e6a&"
import script from "./cardvalue.vue?vue&type=script&lang=js&"
export * from "./cardvalue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports